<script setup lang="ts">
// eslint-disable-next-line vue/block-tag-newline
import SchoolDaySIS from './SchoolDaySIS';
</script>

<template>
  <div>
    <SchoolDaySIS />
  </div>
</template>
